import { render, staticRenderFns } from "./CourseProgramOutcomeMatrix.vue?vue&type=template&id=20f68b63"
import script from "./CourseProgramOutcomeMatrix.vue?vue&type=script&lang=js"
export * from "./CourseProgramOutcomeMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports